export type ScanDataFields =
  | 'date'
  | 'manufacturer'
  | 'model'
  | 'exposure'
  | 'fov'
  | 'voxel';

export const SCAN_DATA_FIELDS: ScanDataFields[] = [
  'date',
  'manufacturer',
  'model',
  'exposure',
  'fov',
  'voxel',
];

export const PREVIEW_SCAN_DATA_FIELDS: ScanDataFields[] = [
  'manufacturer',
  'voxel',
  'fov',
  'model',
  'exposure',
];

export const STUDY_IMAGE_DATE_FORMAT = 'MMMM d, Y';
